/** Converte o JSON real do CRM de produção para o formato do popup. Sem dados fictícios. */

export const CORES = [
  '#10b981',
  '#8b5cf6',
  '#f59e0b',
  '#ef4444',
  '#3b82f6',
  '#ec4899',
  '#14b8a6',
  '#64748b',
];

export const normalizarDigitos = valor => String(valor || '').replace(/\D/g, '');

export const normalizarTelefone = (tel, ddi) => {
  const d = normalizarDigitos(tel);
  const cc = normalizarDigitos(ddi);
  if (!d) return '';
  if (cc && !d.startsWith(cc)) return `${cc}${d}`;
  return d;
};

export const formatarTelefone = (tel, ddi) => {
  const d = normalizarTelefone(tel, ddi);
  if (!d) return '';
  if (d.startsWith('55') && (d.length === 12 || d.length === 13)) {
    const rest = d.slice(2);
    if (rest.length === 11) {
      return `+55 (${rest.slice(0, 2)}) ${rest.slice(2, 7)}-${rest.slice(7)}`;
    }
    return `+55 (${rest.slice(0, 2)}) ${rest.slice(2, 6)}-${rest.slice(6)}`;
  }
  return `+${d}`;
};

export const temNome = c => !/^\+?\d+$/.test(String(c?.nome || '').trim());

export const casaBusca = (c, busca, soComNome) => {
  if (soComNome && !temNome(c)) return false;
  const q = String(busca || '').trim().toLowerCase();
  if (!q) return true;
  const qDigitos = q.replace(/\D/g, '');
  const tel = String(c.telefone || '');
  return (
    String(c.nome || '')
      .toLowerCase()
      .includes(q) || (qDigitos.length > 0 && tel.includes(qDigitos))
  );
};

export const mapearContato = c => {
  const tel = normalizarTelefone(c?.telefone, c?.ddi);
  const nome = String(c?.nome || '').trim() || (tel ? `+${tel}` : 'Sem nome');
  return {
    id: String(c?.id || ''),
    nome,
    telefone: tel,
    ddi: c?.ddi || '+55',
    nota: c?.anotacoes || c?.nota || '',
    criadoEm: c?.criadoEm || null,
    tags: Array.isArray(c?.tags) ? c.tags : [],
    automacaoAtiva: c?.automacaoAtiva !== false,
    chatwootContactId: c?.chatwootContactId || null,
  };
};

export const mapearFunil = (pipeMeta, board) => {
  const meta = pipeMeta || {};
  const pipeId = String(meta.id || board?.pipelineId || '');
  let cols = Array.isArray(board?.colunas) ? board.colunas.slice() : [];
  // Board sem pipelineId mistura funis — restringe às colunas deste funil.
  if (pipeId) {
    const filtradas = cols.filter(
      col => !col?.pipelineId || String(col.pipelineId) === pipeId
    );
    if (filtradas.length) cols = filtradas;
  }
  const colIds = new Set(cols.map(c => String(c.id)));
  const cts = Array.isArray(board?.contatos) ? board.contatos : [];
  const totais = board?.totais && typeof board.totais === 'object' ? board.totais : {};
  const byCol = {};
  cts.forEach(c => {
    const id = c?.colunaId;
    if (!id || (colIds.size && !colIds.has(String(id)))) return;
    if (!byCol[id]) byCol[id] = [];
    byCol[id].push(mapearContato(c));
  });
  cols.sort((a, b) => (Number(a?.ordem) || 0) - (Number(b?.ordem) || 0));
  return {
    id: pipeId,
    nome: String(meta.nome || 'Funil'),
    padrao: !!(meta.principal || meta.padrao),
    colunas: cols.map(col => ({
      id: String(col.id),
      titulo: String(col.titulo || col.nome || 'Coluna'),
      cor: col.cor || CORES[0],
      pipelineId: String(col.pipelineId || pipeId || ''),
      contatos: byCol[col.id] || byCol[String(col.id)] || [],
      total:
        totais[col.id] ??
        totais[String(col.id)] ??
        (byCol[col.id] || byCol[String(col.id)] || []).length,
    })),
  };
};

export const paginarBoard = (board, opts = {}) => {
  const limit = Math.min(5000, Math.max(1, Number(opts.limit) || PAGINA));
  const offset = Math.max(0, Number(opts.offset) || 0);
  const colunaId = opts.colunaId ? String(opts.colunaId) : '';
  const q = String(opts.q || '');
  const cols = Array.isArray(board?.colunas) ? board.colunas : [];
  let cts = Array.isArray(board?.contatos) ? board.contatos : [];
  const ql = q.trim().toLowerCase();
  const qd = q.replace(/\D/g, '');
  if (ql) {
    cts = cts.filter(c => {
      const nome = String(c?.nome || '').toLowerCase();
      const tel = String(c?.telefone || '');
      return nome.includes(ql) || (qd && tel.includes(qd));
    });
  }
  const totais = {};
  const by = {};
  cts.forEach(c => {
    const id = c?.colunaId;
    if (!id) return;
    totais[id] = (totais[id] || 0) + 1;
    (by[id] ||= []).push(c);
  });
  const picked = [];
  cols.forEach(col => {
    if (colunaId && String(col.id) !== colunaId) return;
    picked.push(...(by[col.id] || []).slice(offset, offset + limit));
  });
  return {
    ok: true,
    colunas: cols,
    contatos: picked,
    totais,
    total: cts.length,
    limit,
    offset,
    pipelineId: board?.pipelineId,
  };
};

export const montarListaFunis = (pipes, funilAtivo) => {
  const lista = Array.isArray(pipes) ? pipes : [];
  return lista.map(p => {
    if (funilAtivo && String(p.id) === String(funilAtivo.id)) return funilAtivo;
    return {
      id: String(p.id),
      nome: String(p.nome || 'Funil'),
      padrao: !!(p.principal || p.padrao),
      colunas: [],
    };
  });
};

export const delayValido = (min, max) => {
  const a = Number(min);
  const b = Number(max);
  return !Number.isNaN(a) && !Number.isNaN(b) && a >= 0 && b <= 120 && a <= b;
};

export const payloadFollowup = (followup, iaTravada) => ({
  ativo: iaTravada ? false : !!followup?.ativo,
  minutos: Number(followup?.minutos) || 30,
  instrucoes: String(followup?.instrucoes || ''),
});

export const PAGINA = 40;
export const LIMITE_CARDS = PAGINA;
